<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Set Balance</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>

		</v-toolbar>

		<div class="display hasToolbar">

			<v-list class="section-container" two-line>
		        <div>
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Party</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.party}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div>
		        <div>
		        	<v-list-tile>
		          		<v-list-tile-content>
		          			<v-list-tile-title>Date</v-list-tile-title>
		              		<v-list-tile-sub-title>{{displayData.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
		            	</v-list-tile-content>
		        	</v-list-tile>
		        	<v-divider></v-divider>
		        </div>
		        <div v-if="ledgerData">
		       		<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Amount</v-list-tile-title>
			              	<v-list-tile-sub-title>&#8377; {{$root.numberToLocale(displayData.amount)}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>

		    </v-list>
		</div>

		<!-- <dialog-confirmation ref="ref_dialogCancelDeleteTransaction" header="Delete Transaction?" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true'></dialog-confirmation> -->
		<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" header="Delete Transaction?" confirmationMessage="Deleted transaction cannot be restored. Are you sure you want to delete this transaction?" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true' okBtnText="Yes" cancelBtnText="No" icon="warning" iconClass="redcolor" textClass="redcolor"></dialog-confirmation>

	</div>
</template>

<script>

import dialogConfirmation from '../../../dialogs/dialog_confirmation'
const menuItem = require('../../../../config.js').configs.menuItem;

import {transactionMixin} from '../../transaction_mixin'
	export default{
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{},
				ledgerData:null,
				amountType:null,
				// confirmationMessage:null
			}
		},
		components:{
			'dialog-confirmation':dialogConfirmation
		},
		methods:{

			fn_getBottomMenu: function () {
				let bottomMenu = null;

				bottomMenu = {"BottomMenu": [menuItem.delete]};

				this.setBottomMenu(null, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='delete'){
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
			},

			fn_callCancelTransaction: function(){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				let self = this;
				// let transactionNumber = this.displayData.mergeTransactionNumber;
				this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
					if(status){
						self.showToast('Set balance entry deleted');
						self.$router.go(-1);
					}
					else{
						self.showToast('Something went wrong. Try again');
					}
				});
			},

			fn_get: function(itemId){
				var self = this;
		  		this.getData('GetPartySetBalance', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
				          if(self.displayData.transactionLedgers && self.displayData.transactionLedgers.length){
				          	self.amountType = self.displayData.transactionLedgers[0].amountType == 1 ? '(Positive)' : '(Negative)';
				          }

				          self.fn_getLedgerData(self.displayData.partyId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getLedgerData: function(selectedValueId){
				let self = this;
				this.getData('Ledger', selectedValueId, 
					{
						onSuccess: function(response){
							console.log(response);

							self.ledgerData = JSON.parse(response);
							// !self.Form.transactionData.transactionId ? self.fn_showHideBwb() : self.fn_changeAmountType(self.Form.amountType);

				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_showWebView();
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/party_balance/display.vue